import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contact-info" }
const _hoisted_2 = { class: "contact-info__field" }
const _hoisted_3 = { class: "contact-info__field--text" }
const _hoisted_4 = { class: "contact-info__field--text-weight" }
const _hoisted_5 = { class: "contact-info__field--text-weight" }
const _hoisted_6 = { class: "contact-info__field--buttons" }
const _hoisted_7 = { class: "contact-info__field" }
const _hoisted_8 = { class: "contact-info__field-radio" }
const _hoisted_9 = {
  class: "contact-info__field--buttons",
  style: {"justify-content":"center"}
}
const _hoisted_10 = { class: "contact-info__field" }
const _hoisted_11 = { class: "contact-info__field-radio" }
const _hoisted_12 = { class: "contact-info__field--buttons" }
const _hoisted_13 = { class: "contact-info__field" }
const _hoisted_14 = {
  style: {"align-self":"center","max-width":"204px"},
  class: "contact-info__field--text"
}
const _hoisted_15 = {
  style: {"align-self":"center"},
  class: "contact-info__field--buttons"
}
const _hoisted_16 = { class: "contact-info__field" }
const _hoisted_17 = { class: "contact-info__field--text" }
const _hoisted_18 = { class: "contact-info__field--text-weight" }
const _hoisted_19 = { class: "contact-info__field--buttons" }
const _hoisted_20 = { class: "contact-info__field" }
const _hoisted_21 = { class: "contact-info__field--text" }
const _hoisted_22 = { class: "contact-info__field--text-weight" }
const _hoisted_23 = {
  key: 0,
  style: {"font-weight":"400","color":"#4d4d4d"}
}
const _hoisted_24 = { class: "contact-info__field--buttons" }
const _hoisted_25 = { class: "contact-info__field" }
const _hoisted_26 = { class: "contact-info__field--text" }
const _hoisted_27 = { class: "contact-info__field--text-weight" }
const _hoisted_28 = { class: "contact-info__field--buttons" }
const _hoisted_29 = { class: "contact-info__field" }
const _hoisted_30 = { class: "contact-info__field--text" }
const _hoisted_31 = { class: "contact-info__field--text-weight" }
const _hoisted_32 = { class: "contact-info__field--buttons" }

import FileCard from "./FileCard.vue";
import FileString from "../FileString.vue";
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import AppRadioButton from "@/components/ui-kit/radio-button/AppRadioButton.vue";
import {
  FileInfoContainer,
  FileOut,
  FolderOut,
} from "@/models/interfaces/file/file-model";

type ModalPosition = { x: number; y: number };

interface Props {
  type?:
    | "replace"
    | "move"
    | "error"
    | "replaceUpload"
    | "remove"
    | "removeFile"
    | "removeFolder"
    | "abortFile";
  errorType?: string;
  position?: ModalPosition | null;
  // files?: FileOut[];
}

const MODAL_WIDTH = 235;
const MODAL_HEIGHT_FALLBACK = 160;
const MODAL_MARGIN = 8;


export default /*@__PURE__*/_defineComponent({
  __name: 'FileMoveModal',
  props: {
    type: { default: "move" },
    errorType: { default: "size" },
    position: {}
  },
  emits: [
  "successMove",
  "successReplace",
  "successReplaceUpload",
  "successRemove",
  "successRemoveFile",
  "successRemoveFolder",
  "successAbortFile",
  "closeError",
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const selectedReplaceOption = ref<boolean>(true);

const $modal = ref<InstanceType<typeof FileCard> | null>(null);
const isLoading = ref(false);
const isActive = ref(false);
const targetDir = ref<FolderOut>();
const targetFile = ref<FileOut>();
const countEl = ref();
const errorText = ref("");
const replaceFile = [
  { text: "Оставить текущее название", value: false },
  { text: "Применить новое название", value: false },
];

const props = __props;

const pluralize = (
  n: number,
  one: string,
  few: string,
  many: string,
): string => {
  const abs = Math.abs(n) % 100;
  const mod10 = abs % 10;
  if (abs >= 11 && abs <= 19) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
};

const label = computed(() => {
  const n = countEl.value ?? 0;
  return `${n} ${pluralize(n, "элемент", "элемента", "элементов")}`;
});

const getCenteredPosition = (): ModalPosition => ({
  x: window.scrollX + (window.innerWidth - MODAL_WIDTH) / 2,
  y: window.scrollY + (window.innerHeight - MODAL_HEIGHT_FALLBACK) / 2,
});

const safePosition = computed<ModalPosition>(() => {
  const raw = props.position;

  const position =
    raw &&
    Number.isFinite(raw.x) &&
    Number.isFinite(raw.y) &&
    !(raw.x === 0 && raw.y === 0)
      ? raw
      : getCenteredPosition();

  const minX = window.scrollX + MODAL_MARGIN;
  const minY = window.scrollY + MODAL_MARGIN;

  const maxX = window.scrollX + window.innerWidth - MODAL_WIDTH - MODAL_MARGIN;

  const maxY =
    window.scrollY + window.innerHeight - MODAL_HEIGHT_FALLBACK - MODAL_MARGIN;

  return {
    x: Math.min(Math.max(position.x, minX), maxX),
    y: Math.min(Math.max(position.y, minY), maxY),
  };
});

const success = () => {
  switch (props.type) {
    case "replace":
      emit("successReplace", selectedReplaceOption.value);
      $modal.value?.onClose();
      break;

    case "move":
      emit("successMove", targetDir.value);
      $modal.value?.onClose();
      break;

    case "replaceUpload":
      emit("successReplaceUpload", selectedReplaceOption.value);
      $modal.value?.onClose();
      break;

    case "remove":
      emit("successRemove");
      $modal.value?.onClose();
      break;

    case "removeFile":
      emit("successRemoveFile", targetDir.value, targetFile.value);
      $modal.value?.onClose();
      break;

    case "removeFolder":
      emit("successRemoveFolder", targetDir.value);
      $modal.value?.onClose();
      break;

    case "abortFile":
      emit("successAbortFile");
      $modal.value?.onClose();
      break;

    case "error":
      emit("closeError");
      $modal.value?.onClose();
      break;
  }

  $modal.value?.onClose();
};

const chooseError = () => {
  switch (props.errorType) {
    case "size":
      errorText.value = "Размер файла не должен превышать 100 Мб";
      break;

    case "extension":
      errorText.value = "Форматы файлов не совпадают";
      break;

    case "folder":
      errorText.value = "Вы не можете добавить внешнюю папку";
      break;

    case "notFound":
      errorText.value = "Файл не найден";
      break;

    case "folderNameMatch":
      errorText.value = "Папка с таким названием уже существует";
      break;

    case "fileNameMatch":
      errorText.value = "Файл с таким названием уже существует";
      break;

    case "chooseAccessDenied":
      errorText.value =
        "Вы не можете выбрать папку целиком, потому что у вас нет доступа к некоторым файлам";
      break;
  }

  // $modal.value?.onClose();
};

onMounted(() => {
  window.addEventListener("keydown", handleEsc, true);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEsc, true);
});

const handleEsc = async (e: KeyboardEvent) => {
  if (e.key !== "Escape") {
		return
  }
  if (!isActive.value) {
		return
  }

  e.stopPropagation();
  $modal.value?.onClose();
};

const onClose = () => {
  isActive.value = false;
  $modal.value?.onClose();
};

const onOpen = async (dir?: FolderOut, count?: number, file?: FileOut) => {
  try {
    $modal.value?.onOpen();
    isActive.value = true;

    await nextTick();

    targetDir.value = dir;
    targetFile.value = file;
    countEl.value = count;

    if (props.type == "error") {
      chooseError();
    }
  } catch (e) {
    console.error(e);
  }
};

__expose({ onOpen, onClose });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FileCard, {
    ref_key: "$modal",
    ref: $modal,
    onOnClose: _cache[4] || (_cache[4] = ($event: any) => (isActive.value = false)),
    position: safePosition.value,
    loading: isLoading.value,
    height: "auto",
    width: "235px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.type == 'move')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "contact-info__header" }, "Переместить элементы?", -1)),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[5] || (_cache[5] = _createTextVNode(" Вы собираетесь перенести ")),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(label.value), 1),
                  _cache[6] || (_cache[6] = _createTextVNode(" в папку ")),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(targetDir.value?.Name), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: "Отмена",
                    onClick: onClose
                  }),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: "Подтвердить",
                    onClick: success
                  })
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'replace')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "contact-info__header" }, "Замена файла", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(AppRadioButton, {
                    modelValue: selectedReplaceOption.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedReplaceOption).value = $event)),
                    text: "Оставить текущее название",
                    name: "answer",
                    "radio-value": true
                  }, null, 8, ["modelValue"]),
                  _createVNode(AppRadioButton, {
                    modelValue: selectedReplaceOption.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedReplaceOption).value = $event)),
                    text: "Применить новое название",
                    name: "answer",
                    "radio-value": false
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: "Отмена",
                    onClick: onClose
                  }),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: "Заменить",
                    onClick: success
                  })
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'replaceUpload')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "contact-info__header" }, " Файл с таким названием уже существует ", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(AppRadioButton, {
                    modelValue: selectedReplaceOption.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedReplaceOption).value = $event)),
                    text: "Заменить файл",
                    name: "answer",
                    "radio-value": true
                  }, null, 8, ["modelValue"]),
                  _createVNode(AppRadioButton, {
                    modelValue: selectedReplaceOption.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedReplaceOption).value = $event)),
                    text: "Оставить обе версии",
                    name: "answer",
                    "radio-value": false
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: "Отмена",
                    onClick: onClose
                  }),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: "Подтвердить",
                    onClick: success
                  })
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'error')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "contact-info__header" }, "Ошибка", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(errorText.value), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(AppButton, {
                    type: "primary",
                    label: "Ок",
                    onClick: success
                  })
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'remove')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "contact-info__header" }, "Удалить элементы?", -1)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[11] || (_cache[11] = _createTextVNode(" Вы собираетесь удалить ")),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(label.value), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: "Отмена",
                    onClick: onClose
                  }),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: "Подтвердить",
                    onClick: success
                  })
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'removeFile')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "contact-info__header" }, "Удалить файл?", -1)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[13] || (_cache[13] = _createTextVNode(" Вы собираетесь удалить файл ")),
                  _createElementVNode("span", _hoisted_22, [
                    _createTextVNode(_toDisplayString(targetFile.value?.Name), 1),
                    (targetFile.value?.JobBindings.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "."))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(targetFile.value?.JobBindings.length > 0
                ? targetFile.value?.JobBindings.length > 1
                  ? `Он прикреплён ${targetFile.value?.JobBindings.length} ${
                      targetFile.value?.JobBindings.length % 10 == 1 &&
                      targetFile.value?.JobBindings.length !== 11
                        ? "работе"
                        : "работам"
                    }.`
                  : "Он прикреплён к работе."
                : ""), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: "Отмена",
                    onClick: onClose
                  }),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: "Подтвердить",
                    onClick: success
                  })
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'removeFolder')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "contact-info__header" }, "Удалить папку?", -1)),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[15] || (_cache[15] = _createTextVNode(" Вы собираетесь удалить папку ")),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(targetDir.value?.Name), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: "Отмена",
                    onClick: onClose
                  }),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: "Подтвердить",
                    onClick: success
                  })
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'abortFile')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "contact-info__header" }, "Прервать загрузку?", -1)),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _cache[17] || (_cache[17] = _createTextVNode(" Вы собираетесь прервать загрузку файла ")),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(targetFile.value?.Name), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: "Отмена",
                    onClick: onClose
                  }),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: "Подтвердить",
                    onClick: success
                  })
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["position", "loading"]))
}
}

})